import React from 'react';
import { useTable, useFlexLayout } from 'react-table';
import { capitalize } from 'lodash';
import View from './View';
import Text from './Text';
import { Theme } from '../../../theme';

const getStyles = (props: any, align = 'left') => [
  props,
  {
    style: {
      justifyContent: align === 'right' ? 'flex-end' : 'flex-start',
      alignItems: 'flex-start',
      display: 'flex',
    },
  },
];

const headerProps = (props: any, { column }: any) =>
  getStyles(props, column.align);

const cellProps = (props: any, { cell }: any) =>
  getStyles(props, cell.column.align);

interface PrimaryTableProps {
  data: any[];
  columns: any[];
  subTable?: any;
  name?: string;
}

const PrimaryTable = ({ data, columns, subTable }: PrimaryTableProps) => {
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable(
      {
        columns,
        data,
        defaultColumn: {
          width: 100,
        },
      },
      useFlexLayout,
    );

  return (
    <View {...getTableProps()} fontSize="10pt">
      <View pb={2} fixed>
        {headerGroups.map((headerGroup) => {
          const { key: hgKey, ...hgProps } = headerGroup.getHeaderGroupProps();
          return (
            <View
              key={hgKey}
              {...hgProps}
              borderBottom={`2pt solid ${Theme.colors.primary}`}
              flexDirection="row"
              alignItems="center"
              justifyContent="center"
            >
              {headerGroup.headers.map((column) => {
                const { key: colKey, ...colProps } =
                  column.getHeaderProps(headerProps);
                return (
                  <View key={colKey} {...colProps} p="5pt" fontSize="10pt">
                    <Text>{column.render('Header')}</Text>
                  </View>
                );
              })}
            </View>
          );
        })}
      </View>
      <View {...getTableBodyProps()}>
        {rows.map((row) => {
          prepareRow(row);
          const { key: rowKey, ...rowProps } = row.getRowProps();
          return (
            <View key={rowKey} {...rowProps}>
              <View
                {...rowProps}
                flexDirection="row"
                justifyContent="center"
                alignItems="center"
                borderBottom={`1pt solid ${Theme.colors.greyLight}`}
              >
                {row.cells.map((cell) => {
                  const { key: cellKey, ...cProps } =
                    cell.getCellProps(cellProps);
                  return (
                    <View key={cellKey} {...cProps} fontSize="8pt" p="5pt">
                      <Text>{cell.render('Cell')}</Text>
                    </View>
                  );
                })}
              </View>
              {subTable && row.original[subTable.accessor] && (
                <SubTable
                  data={row.original[subTable.accessor]}
                  {...subTable}
                />
              )}
            </View>
          );
        })}
      </View>
    </View>
  );
};

interface SubTableProps {
  data: any[];
  columns: any[];
  title?: string;
}

const SubTable = ({ data, columns, title }: SubTableProps) => (
  <View
    style={{
      alignItems: 'center',
    }}
  >
    <View
      style={{
        width: '95%',
        backgroundColor: Theme.colors.greyLightest,
      }}
    >
      <Text
        style={{
          fontSize: 14,
          paddingTop: 4,
          paddingLeft: 4,
          width: '100%',
          color: Theme.colors.greyLight,
        }}
        fixed
      >
        {capitalize(title)}
      </Text>
      <PrimaryTable data={data} columns={columns} />
    </View>
  </View>
);

export default PrimaryTable;
